import { captureException } from "@sentry/react";
import axios from "axios";

interface Event {
  event: string;
  eventName: string;
  createdAt: string;
  personUuid: string;
  subscriptionUuid: string;
  properties: object; // Change the type to match your specific properties
}

const MixPanelMetrics = {
  sendEvent: async (event: Event) => {
    // Send event to MixPanel
    const token = localStorage.getItem("user-token");

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_DELEND_API}/metrics/v1/events`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: event,
    };

    try {
      await axios(config);
    } catch (error) {
      captureException(error);
    }
  },
};

export default MixPanelMetrics;
